<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="标题">
								<a-input v-model="queryParams.title" placeholder="请输入标题" />
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker
										v-model="createTime"
										style="width:100%"
										@change="onCreateTime"
									/>
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span
								class="x-filter-submit-box"
								:style="advanced && { float: 'right', overflow: 'hidden' } || {}"
							>
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="resetQuery">重置</a-button>
								<a style="margin-left: 8px" @click="toggleAdvanced">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/content/articleAdd'" @click="add">新增</a-button>
			</div>

			<a-table
				:rowKey="record => record.id"
				:columns="tableColumns"
				:loading="tableLoading"
				:dataSource="tableData"
				:pagination="false"
			>
				<template slot="cover" slot-scope="record">
					<x-image
						v-if="record.coverUrl"
						:src="record.coverUrl"
						:preview-src="record.coverUrl"
					/>
					<span v-else>-</span>
				</template>
				<template slot="summary" slot-scope="text">
					<span class="summary-cell">{{ text || '-' }}</span>
				</template>
				<template slot="action" slot-scope="record">
					<a v-has="'/content/articleUpdate'" @click="update(record)">修改</a>
					<a-divider type="vertical" />
					<a-popconfirm
						title="确定要删除这篇文章吗？"
						okText="确定"
						cancelText="取消"
						@confirm="deleteRecord(record)"
					>
						<a href="javascript:;" v-has="'/content/articleDel'" style="color: #ff4d4f;">删除</a>
					</a-popconfirm>
				</template>
			</a-table>

			<div class="x-pagination">
				<a-pagination
					:pageSize="pageSize"
					v-model="pageIndex"
					:total="totalRow"
					:hideOnSinglePage="true"
					show-less-items
					@change="pageChange"
				/>
			</div>

			<article-form-modal
				ref="articleFormModal"
				:visible="formVisible"
				:loading="formLoading"
				@ok="formOk"
				@cancel="formCancel"
			/>
		</a-card>
	</div>
</template>

<script>
import moment from 'moment';
import XImage from '@/components/XImage';
import ArticleFormModal from './ArticleFormModal.vue';
import {
	articleList,
	articleDetail,
	articleAdd,
	articleUpdate,
	articleDelete
} from '@/api/content/article.js';

const tableColumns = [
	{ title: '#', dataIndex: 'id', width: 70 },
	{ title: '封面', scopedSlots: { customRender: 'cover' }, width: 90 },
	{ title: '标题', dataIndex: 'title' },
	{ title: '摘要', dataIndex: 'summary', scopedSlots: { customRender: 'summary' } },
	{ title: '阅读', dataIndex: 'readNum', width: 80 },
	{ title: '创建时间', dataIndex: 'created', width: 170 },
	{ title: '操作', scopedSlots: { customRender: 'action' }, width: 140 }
];

export default {
	components: {
		XImage,
		ArticleFormModal
	},
	data() {
		return {
			advanced: false,
			queryParams: {},
			tableLoading: false,
			tableColumns,
			tableData: [],
			totalRow: 0,
			pageSize: 20,
			pageIndex: 1,
			createTime: [],
			formVisible: false,
			formLoading: false
		};
	},
	created() {
		this.fetchTableData();
	},
	methods: {
		fetchTableData() {
			this.tableLoading = true;
			this.queryParams.pageSize = this.pageSize;
			this.queryParams.page = this.pageIndex;
			articleList(this.queryParams).then(res => {
				this.tableData = (res && res.data && res.data.recordList) || [];
				this.totalRow = (res && res.data && res.data.totalRow) || 0;
			}).catch(() => {
				this.$message.error('获取列表失败');
			}).finally(() => {
				this.tableLoading = false;
			});
		},
		toggleAdvanced() {
			this.advanced = !this.advanced;
		},
		resetQuery() {
			this.queryParams = {};
			this.createTime = [];
			this.pageIndex = 1;
			this.fetchTableData();
		},
		pageChange(current) {
			this.pageIndex = current;
			this.fetchTableData();
		},
		onCreateTime(values) {
			if (values && values.length === 2) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			} else {
				delete this.queryParams.startCreateTime;
				delete this.queryParams.endCreateTime;
			}
		},
		add() {
			this.$refs.articleFormModal.initForm();
			this.formVisible = true;
		},
		update(record) {
			this.formLoading = true;
			this.formVisible = true;
			articleDetail(record.id).then(res => {
				if (!res || !res.isSucceed) {
					this.$message.error((res && res.message) || '获取详情失败');
					this.formVisible = false;
					return;
				}
				this.$refs.articleFormModal.setForm(res.data || {});
			}).catch(() => {
				this.$message.error('获取详情失败');
				this.formVisible = false;
			}).finally(() => {
				this.formLoading = false;
			});
		},
		formOk() {
			this.$refs.articleFormModal.validate((valid, formData) => {
				if (!valid) {
					return;
				}
				this.formLoading = true;
				const submitData = {
					id: formData.id || 0,
					title: formData.title || '',
					content: formData.content || '',
					summary: formData.summary || ''
				};
				const promise = submitData.id > 0
					? articleUpdate(submitData)
					: articleAdd(submitData);
				promise.then(res => {
					if (!res || res.isSucceed === false) {
						this.$message.error((res && res.message) || '操作失败');
						return;
					}
					this.$message.success(submitData.id > 0 ? '修改成功' : '新增成功');
					this.formVisible = false;
					this.fetchTableData();
				}).catch(() => {
					this.$message.error('操作失败');
				}).finally(() => {
					this.formLoading = false;
				});
			});
		},
		formCancel() {
			this.formVisible = false;
		},
		deleteRecord(record) {
			articleDelete(record.id).then(res => {
				if (!res || res.isSucceed === false) {
					this.$message.error((res && res.message) || '删除失败');
					return;
				}
				this.$message.success('删除成功');
				this.fetchTableData();
			}).catch(() => {
				this.$message.error('删除失败');
			});
		}
	}
};
</script>

<style scoped>
.summary-cell {
	display: inline-block;
	max-width: 280px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	vertical-align: bottom;
}
</style>
